/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Letters/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import Letter from './Letter/index'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'
import useListItemDataOnChange from './useListItemDataOnChange.js'



/** @type {import('Simple/types.js').View} */
export default function Letters({
  children,
  viewPath = "/DesignSystem/GenerateLettersModal/Content/Letters"
  
}) {
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtColorsNeutral200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.200'
        })
let dtTypographyFontsizeM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'typography.fontSize.m'
        })
let modalLettersValueData = fromData.useDataValue({ viewPath,
context: 'modal',
path: 'letters',
})
  return (<React.Fragment
>
<div
  data-testid="Letters.Horizontal"
  data-view-path={viewPath}
 style={{'--pl-1-23a8Eu': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pr-2-23a8Eu': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pt-3-23a8Eu': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pb-4-23a8Eu': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--g-5-23a8Eu': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--bbc-6-23a8Eu': dtColorsNeutral200}}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 width={228}
 fontSize={dtTypographyFontsizeM}
 weight="medium"
 text="Letters"
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 width={162}
 fontSize={dtTypographyFontsizeM}
 weight="medium"
 text="Recipient"
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 width={144}
 fontSize={dtTypographyFontsizeM}
 weight="medium"
 text="Status"
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 width={194}
 fontSize={dtTypographyFontsizeM}
 weight="medium"
 text="Actions"
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 width={16}
/>
</div>
<div
  data-testid="Letters.List"
  data-view-path={viewPath}
 className="views-block"
>
{Array.isArray(modalLettersValueData) && modalLettersValueData.map((item, index, list) => 
<ListItem
        key={item?.id ?? item?._id ?? index}
        context="letter"
        item={item}
        index={index}
        list={list}
        hasItemKey={false}
        parentViewPath={viewPath}
        viewPath={`${viewPath}/Letter(${item?.id ?? item?._id ?? index})`}
      >
<Letter
 index={index} indexReverse={list.length - index} isFirst={index === 0} isLast={index === list.length - 1}
 item={item}
 viewPath={`${viewPath}/Letter(${item?.id ?? item?._id ?? index})`}
/>
</ListItem>
)}
</div>
{children}
</React.Fragment>)
}

  function ListItem(props) {
    let valueItem = React.useMemo(() => ({
      index: props.index,
      indexReverse: props.list.length - props.index,
      isFirst: props.index === 0,
      isLast: props.index === props.list.length - 1,
    }), [props.index, props.list])
    let onChange = useListItemDataOnChange({ ...props, viewPath: props.parentViewPath })
    
    
    return (
      <fromData.DataProvider
      context={props.context}
      value={props.item}
      onChange={onChange}
      
      viewPath={props.viewPath}
    >
      <fromData.DataProvider
        context={`${props.context}_item`}
        value={valueItem}
        viewPath={props.viewPath}
      >
        {props.children}
      </fromData.DataProvider>
    </fromData.DataProvider>
    )
  }